module.exports = __webpack_public_path__ + "static/media/19.6a1ce8dd.mp3";